// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__sezuW","actionsCol":"EnrolledClinics_actionsCol__9zGXV"};